import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import MovingBackground from "./MovingBackground";

const ease = [0.16, 1, 0.3, 1] as const;

const testimonials = [
  {
    quote: "Jesper transformed our approach to AI. Within weeks we had a governed Copilot deployment that people actually use and trust.",
    author: "CTO",
    company: "Nordic Enterprise (2,500 employees)",
  },
  {
    quote: "The governance framework gave our board the confidence to invest heavily in AI agents. Measurable ROI from month one.",
    author: "Head of Digital",
    company: "Danish Financial Services",
  },
];

const TestimonialSlide = ({ thumbnail }: { thumbnail?: boolean }) => (
  <div className="relative w-full h-full flex flex-col items-center justify-center bg-background overflow-hidden">
    <MovingBackground variant="particles" />

    <div className="relative z-10 w-full max-w-4xl px-8">
      <motion.div
        className="text-center mb-6 md:mb-10"
        initial={thumbnail ? false : { opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease }}
      >
        <p className="label-text mb-2" style={{ fontSize: thumbnail ? "0.5rem" : undefined }}>
          Client Voices
        </p>
        <h2
          className="font-display font-bold text-foreground"
          style={{ fontSize: thumbnail ? "0.9rem" : "clamp(1.5rem, 3vw, 2.5rem)" }}
        >
          Trusted by <span className="text-gradient">Leaders</span>
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-2 gap-4 md:gap-8">
        {testimonials.map((t, i) => (
          <motion.div
            key={i}
            className="bg-card/80 backdrop-blur-sm rounded-xl p-5 md:p-8 border border-border/50 flex flex-col"
            initial={thumbnail ? false : { opacity: 0, y: 30, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ delay: 0.2 + i * 0.15, duration: 0.6, ease }}
          >
            <Quote
              size={thumbnail ? 10 : 28}
              className="text-primary mb-4 opacity-60"
            />
            <p
              className="text-foreground font-body leading-relaxed flex-1 italic"
              style={{ fontSize: thumbnail ? "0.4rem" : "clamp(0.9rem, 1.3vw, 1.15rem)" }}
            >
              "{t.quote}"
            </p>
            <div className="mt-4 pt-4 border-t border-border/50">
              <p
                className="font-display font-semibold text-foreground"
                style={{ fontSize: thumbnail ? "0.4rem" : "0.95rem" }}
              >
                {t.author}
              </p>
              <p
                className="text-muted-foreground"
                style={{ fontSize: thumbnail ? "0.35rem" : "0.8rem" }}
              >
                {t.company}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </div>
);

export default TestimonialSlide;
